var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConversation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#685ce5;}.cls-2{fill:none;}.cls-3{fill:#ffd022;}.cls-4{fill:#a291f9;}.cls-5{stroke:#fff;stroke-linecap:round;stroke-width:2px;}.cls-5,.cls-6{fill:none;stroke-miterlimit:10;}.cls-6{stroke:#c96106;stroke-width:5.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 150,
    height: 175
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 11.16,
    y: 124.08,
    width: 18.53,
    height: 22.87,
    rx: 9.26,
    ry: 9.26,
    transform: "translate(40.85 271.03) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38.01,117.26h15.27c8.85,0,16.03,7.18,16.03,16.03v34.55c0,2.53-2.05,4.59-4.59,4.59H26.56c-2.53,0-4.59-2.05-4.59-4.59v-34.55c0-8.85,7.18-16.03,16.03-16.03Z",
    transform: "translate(91.29 289.69) rotate(-180)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M140.8,68.74V23.92c0-7.04-5.76-12.8-12.8-12.8H57.58c-7.04,0-12.8,5.76-12.8,12.8V107.15l12.71-12.71c8.26-8.26,19.46-12.9,31.14-12.9h39.38c7.04,0,12.8-5.76,12.8-12.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.49,82.98c-7.51,1.96-14.43,5.88-20.01,11.47l-12.71,12.71v-12.81c0-9.37,8.64-16.37,17.79-14.4,5.76,1.24,11.31,2.84,14.92,3.04Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 67.95,
    y1: 33.06,
    x2: 116.42,
    y2: 33.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 67.95,
    y1: 45.48,
    x2: 96.16,
    y2: 45.48
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversation);
export default __webpack_public_path__ + "static/media/conversation.40938d12a76c9a1294800b50a516eb2b.svg";
export { ForwardRef as ReactComponent };